// Fixture mode: ?fixture=1 (remembered for the tab, since Ionic's router
// drops the query string) or VITE_FIXTURE=1. ?fixture=0 turns it off.
// ?as=operator|supervisor|admin and ?person=Name set who fixture mode signs in as.
const KEY = "oc.fixture";

function readParams() {
  try {
    const q = new URLSearchParams(window.location.search);
    if (q.has("fixture")) sessionStorage.setItem(KEY, q.get("fixture") === "0" ? "0" : "1");
    for (const k of ["as", "person"]) if (q.has(k)) sessionStorage.setItem(`oc.fixture.${k}`, q.get(k) ?? "");
  } catch { /* storage blocked: env only */ }
}
readParams();

export function fixtureMode(): boolean {
  if (import.meta.env.VITE_FIXTURE === "1") return true;
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function fixtureParam(k: "as" | "person"): string | null {
  try { return sessionStorage.getItem(`oc.fixture.${k}`) || null; } catch { return null; }
}

/**
 * The fixture's clock: Tuesday 3 Nov 2026, 16:40 (web/scripts/make-fixtures.mjs
 * uses the same moment): most of Tuesday is logged, the 16:45 count is due.
 */
export const FIXTURE_NOW = { day: "2026-11-03", minute: 16 * 60 + 40 } as const;
